var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-stops"},[_c('r-table-list',{attrs:{"data":_vm.stops,"fields-names":_vm.fieldsExplanation},on:{"click-handler":_vm.rowClickHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }